import { useEffect, useRef } from 'react';

const SHOPIFY_DOMAIN = 'czvzsu-1d.myshopify.com';
const STOREFRONT_TOKEN = '5d305d1db72256b78ac930a96e13b376';
const PRODUCT_ID = '9353486926038';
const SDK_URL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';

let sdkLoaded = false;
let sdkLoading = false;
let sdkCallbacks = [];

function loadShopifySDK() {
  return new Promise((resolve) => {
    if (window.ShopifyBuy && window.ShopifyBuy.UI) {
      resolve();
      return;
    }
    if (sdkLoaded) { resolve(); return; }
    if (sdkLoading) { sdkCallbacks.push(resolve); return; }
    
    sdkLoading = true;
    const script = document.createElement('script');
    script.async = true;
    script.src = SDK_URL;
    script.onload = () => {
      sdkLoaded = true;
      sdkLoading = false;
      resolve();
      sdkCallbacks.forEach(cb => cb());
      sdkCallbacks = [];
    };
    document.head.appendChild(script);
  });
}

const ShopifyBuyButton = ({ variant = 'default' }) => {
  const containerRef = useRef(null);
  const componentId = useRef(`shopify-btn-${Math.random().toString(36).slice(2, 9)}`);

  useEffect(() => {
    let mounted = true;

    const init = async () => {
      await loadShopifySDK();
      if (!mounted || !containerRef.current) return;

      const client = window.ShopifyBuy.buildClient({
        domain: SHOPIFY_DOMAIN,
        storefrontAccessToken: STOREFRONT_TOKEN,
      });

      const ui = await window.ShopifyBuy.UI.onReady(client);
      if (!mounted || !containerRef.current) return;

      // Clear any previous content
      containerRef.current.innerHTML = '';

      const buttonStyles = variant === 'hero' ? {
        "font-family": "'Manrope', sans-serif",
        "font-weight": "600",
        "font-size": "12px",
        "padding": "14px 40px",
        "letter-spacing": "0.15em",
        "text-transform": "uppercase",
        ":hover": { "background-color": "#3a4d2e" },
        "background-color": "#4A5D3A",
        ":focus": { "background-color": "#3a4d2e" },
      } : variant === 'cta' ? {
        "font-family": "'Manrope', sans-serif",
        "font-weight": "600",
        "font-size": "12px",
        "padding": "14px 40px",
        "letter-spacing": "0.15em",
        "text-transform": "uppercase",
        ":hover": { "background-color": "#3a4d2e" },
        "background-color": "#4A5D3A",
        ":focus": { "background-color": "#3a4d2e" },
      } : {
        "font-weight": "600",
        ":hover": { "background-color": "#3a4d2e" },
        "background-color": "#4A5D3A",
        ":focus": { "background-color": "#3a4d2e" },
      };

      ui.createComponent('product', {
        id: PRODUCT_ID,
        node: containerRef.current,
        moneyFormat: '%24%7B%7Bamount%7D%7D',
        options: {
          "product": {
            "contents": {
              "img": false,
              "title": false,
              "price": false,
              "description": false,
              "button": true,
            },
            "styles": {
              "product": {
                "text-align": variant === 'cta' ? "center" : "left",
              },
              "button": buttonStyles,
            },
            "buttonDestination": "checkout",
            "text": {
              "button": variant === 'hero' ? "Shop Now" : "Order Now"
            }
          },
          "cart": {
            "styles": {
              "button": {
                "font-weight": "600",
                ":hover": { "background-color": "#3a4d2e" },
                "background-color": "#4A5D3A",
                ":focus": { "background-color": "#3a4d2e" },
              }
            },
            "text": { "total": "Subtotal", "button": "Checkout" }
          },
          "toggle": {
            "styles": {
              "toggle": {
                "font-weight": "600",
                "background-color": "#4A5D3A",
                ":hover": { "background-color": "#3a4d2e" },
                ":focus": { "background-color": "#3a4d2e" },
              }
            }
          }
        },
      });
    };

    init();
    return () => { mounted = false; };
  }, [variant]);

  return (
    <div
      ref={containerRef}
      id={componentId.current}
      data-testid={`shopify-buy-btn-${variant}`}
      style={{ display: 'inline-block', minHeight: '50px' }}
    />
  );
};

export default ShopifyBuyButton;
